import api from './client';

// Public and unauthenticated: the same answer for a guest, a member and staff.
export async function fetchMaintenance() {
  return (await api.get('/public/maintenance')).data.data;
}

// Browser event any part of the app raises when a call is refused with the
// maintenance code, so the banner or page appears at once instead of on the
// next poll.
export const MAINTENANCE_CHECK_EVENT = 'moksy:maintenance-check';

export const isMaintenanceRefusal = (error) =>
  /MAINTENANCE|MOKSY_OFFLINE/.test(String(error?.response?.data?.code || error?.response?.data?.error?.code || ''));
